const initialState = {
  list: [],
  loading: 'idle',
};

export default initialState;
